"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSubscriber = void 0;
const memcmp_1 = require("../memcmp");
const web3_js_1 = require("@solana/web3.js");
const buffer_1 = require("buffer");
const DLOB_1 = require("../dlob/DLOB");
const PollingSubscription_1 = require("./PollingSubscription");
const WebsocketSubscription_1 = require("./WebsocketSubscription");
class OrderSubscriber {
    constructor(config) {
        this.usersAccounts = new Map();
        this.driftClient = config.driftClient;
        if (config.subscriptionConfig.type === 'polling') {
            this.subscription = new PollingSubscription_1.PollingSubscription({
                orderSubscriber: this,
                frequency: config.subscriptionConfig.frequency,
            });
        }
        else {
            this.subscription = new WebsocketSubscription_1.WebsocketSubscription({
                orderSubscriber: this,
                skipInitialLoad: config.subscriptionConfig.skipInitialLoad,
            });
        }
    }
    async subscribe() {
        await this.subscription.subscribe();
    }
    async fetch() {
        if (this.fetchPromise) {
            return this.fetchPromise;
        }
        this.fetchPromise = new Promise((resolver) => {
            this.fetchPromiseResolver = resolver;
        });
        try {
            const rpcRequestArgs = [
                this.driftClient.program.programId.toBase58(),
                {
                    commitment: this.driftClient.opts.commitment,
                    filters: [(0, memcmp_1.getUserFilter)(), (0, memcmp_1.getUserWithOrderFilter)()],
                    encoding: 'base64',
                    withContext: true,
                },
            ];
            const rpcJSONResponse = 
            // @ts-ignore
            await this.driftClient.connection._rpcRequest('getProgramAccounts', rpcRequestArgs);
            const rpcResponseAndContext = rpcJSONResponse.result;
            const slot = rpcResponseAndContext.context.slot;
            const programAccountSet = new Set();
            for (const programAccount of rpcResponseAndContext.value) {
                const key = programAccount.pubkey.toString();
                // @ts-ignore
                const buffer = buffer_1.Buffer.from(programAccount.account.data[0], programAccount.account.data[1]);
                programAccountSet.add(key);
                this.tryUpdateUserAccount(key, buffer, slot);
            }
            for (const key of this.usersAccounts.keys()) {
                if (!programAccountSet.has(key)) {
                    this.usersAccounts.delete(key);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.fetchPromiseResolver();
            this.fetchPromise = undefined;
        }
    }
    tryUpdateUserAccount(key, buffer, slot) {
        const slotAndUserAccount = this.usersAccounts.get(key);
        if (!slotAndUserAccount || slotAndUserAccount.slot < slot) {
            const userAccount = this.driftClient.program.account.user.coder.accounts.decode('User', buffer);
            if (userAccount.hasOpenOrder) {
                this.usersAccounts.set(key, { slot, userAccount });
            }
            else {
                this.usersAccounts.delete(key);
            }
        }
    }
    async getDLOB(slot) {
        const dlob = new DLOB_1.DLOB();
        for (const [key, { userAccount }] of this.usersAccounts.entries()) {
            const userAccountPubkey = new web3_js_1.PublicKey(key);
            for (const order of userAccount.orders) {
                dlob.insertOrder(order, userAccountPubkey, slot);
            }
        }
        return dlob;
    }
    async unsubscribe() {
        await this.subscription.unsubscribe();
    }
}
exports.OrderSubscriber = OrderSubscriber;
